module.exports = __webpack_public_path__ + "static/media/poolIcon.d898b87c.svg";